<template>
    <div class="report-graph-data">
        <ReportGraph class="report-graph" :chart-data="datacollection" :barData="createdBarChart" :streamData="cameraData" :height="100"></ReportGraph>
    </div>
</template>

<script>
import ReportGraph from '@/components/report/ReportGraph.vue';

export default {
    props: {
        cameraData: {
            type: Object,
            default: () => {},
            required: false
        }
    },
    components: {
        ReportGraph
    },
    computed: {
        createdLineChart() {
            let line_data = []
            this.cameraData.data_list.forEach((num, index) => {
                if (index !== 0) {
                    line_data.push(this.cameraData.threshold);
                    num;
                }
            });
            return line_data
        },
        createdBarChart() {
            let bar_data = []
            this.cameraData.data_list.forEach((dict, index) => {
                if (index !== 0) {
                    bar_data.push(dict.max)
                }
            });
            return bar_data
        },
        datacollection() {
            return {
                labels: ['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23'],
                datasets: [
                    {
                        label: '設定人数',
                        borderColor: '#f87979',
                        borderWidth:'2',
                        backgroundColor: 'rgba(0,0,0,0)',
                        data: this.createdLineChart,
                        type: 'line'
                    },
                    {
                        label: '最大人数',
                        backgroundColor: '#f8b979',
                        data: this.createdBarChart,
                        type: 'bar'
                    },
                ]
            }
        }
    }
}

</script>

<style scoped>
  .report-graph-data{
    overflow: auto;
  }

  .report-graph{
    min-width: 1000px;
  }
</style>